import React from 'react';
import {useTranslation} from 'react-i18next';
import LenseLogo from './lenseRoundLogo.jsx';

function MadeWithBadge() {
    const {t} = useTranslation();
    const appName = import.meta.env.VITE_APP_NAME || 'Lense';

    return (
        <a href="https://lense.app" target="_blank" rel="noopener noreferrer"
           className="flex items-center justify-center gap-2 py-6 text-white-foreground/50 text-xs hover:text-white-foreground/80 transition">
            <LenseLogo className="w-4 h-4" />
            <span>{t('Made with {{appName}}', {appName})}</span>
        </a>
    );
}

export default MadeWithBadge;
